module.exports = __webpack_public_path__ + "img/img3.b8838206.png";